'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _TextBlock = require('./blocks/TextBlock');

var _TextBlock2 = _interopRequireDefault(_TextBlock);

var _Button = require('./blocks/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Answer = require('./blocks/Answer');

var _Answer2 = _interopRequireDefault(_Answer);

var _RenderHelper = require('./RenderHelper');

var _immutable = require('immutable');

var _RenderWarnings = require('./RenderWarnings');

var _RenderWarnings2 = _interopRequireDefault(_RenderWarnings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var randomize = function randomize(list) {
  var a = list.toJS();
  for (var i = a.length; i; i--) {
    var j = Math.floor(Math.random() * i);
    var _ref = [a[j], a[i - 1]];
    a[i - 1] = _ref[0];
    a[j] = _ref[1];
  }
  return (0, _immutable.fromJS)(a);
};

var RenderQuestion = function (_React$Component) {
  _inherits(RenderQuestion, _React$Component);

  function RenderQuestion() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, RenderQuestion);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = RenderQuestion.__proto__ || Object.getPrototypeOf(RenderQuestion)).call.apply(_ref2, [this].concat(args))), _this), _this.nextHandler = function (handler) {
      return function (evt) {
        if (_this.props.trackEvent) {
          var qsText = _this.props.data.getIn(['question', 'content', 'blocks']);
          qsText = qsText && qsText.first();
          qsText = qsText && qsText.get('text');
          _this.props.trackEvent({
            action: 'Question answered',
            label: qsText + ' = ' + _this.state.selectedAnswers.toIndexedSeq().map(function (a) {
              return a.get('text');
            }).join()
          });
        }

        _this.setState({ selectedAnswers: new _immutable.Map() }, function () {
          return handler(evt);
        });
      };
    }, _this.mountContent = function () {
      var question = _this.props.data.get('question');
      var hint = _this.props.data.get('hint');
      var image = _this.props.data.get('image');

      return _react2.default.createElement(
        'div',
        { className: 'wsequiz_content' },
        question && _react2.default.createElement(_TextBlock2.default, { key: question.get('id'), data: question }),
        hint && _react2.default.createElement(_TextBlock2.default, { key: hint.get('id'), data: hint }),
        image && (0, _RenderHelper.mountImage)(image, { width: _this.props.viewWidth, height: _this.props.viewHeight, crop: 'center' })
      );
    }, _this.mountActions = function () {
      return _react2.default.createElement(
        'div',
        { className: 'wsequiz_action_content' },
        _react2.default.createElement(
          'div',
          { className: 'wsequiz_action_content-inner' },
          _this.answers && _this.answers.map(function (data) {
            return _react2.default.createElement(_Answer2.default, { key: data.get('id'),
              imgParams: {
                width: _this.props.viewHeight,
                height: _this.props.viewHeight,
                crop: 'center'
              },
              data: data,
              isPicture: _this.props.data.get('isPictureAnswers'),
              selected: !!_this.state.selectedAnswers.get(data.get('id')),
              onClick: function onClick() {
                return _this.handleAnswerClick(data);
              }
            });
          }),
          _this.props.data.get('isMultipleAnswers') && _this.props.data.get('primaryButton') && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_Button2.default, {
              data: _this.props.data.get('primaryButton'),
              handleNext: _this.nextHandler(_this.props.handleNext),
              primary: true,
              previewQuizScreen: _this.props.previewQuizScreen,
              trackEvent: _this.props.trackEvent
            })
          )
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RenderQuestion, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({ selectedAnswers: new _immutable.Map() });
      this.updateAnswers(this.props);
      this.timeout = null;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var isSame = function isSame(props1, props2) {
        return (0, _immutable.is)(props1.data.get('answers'), props2.data.get('answers')) && (0, _immutable.is)(props1.data.get('isRandomised'), props2.data.get('isRandomised'));
      };

      if (!isSame(this.props, nextProps)) {
        this.updateAnswers(nextProps);
      }
    }
  }, {
    key: 'updateAnswers',
    value: function updateAnswers(props) {
      this.answers = props.data.get('answers');
      if (this.answers && props.data.get('isRandomised')) {
        this.answers = randomize(this.answers);
      }
    }
  }, {
    key: 'handleAnswerClick',
    value: function handleAnswerClick(answer) {
      var _this2 = this;

      var isMultipleAnswers = this.props.data.get('isMultipleAnswers');
      var hasAnswered = this.state.selectedAnswers.size > 0;
      if (!isMultipleAnswers && hasAnswered) return;

      var selectedAnswers = false;
      if (this.state.selectedAnswers.get(answer.get('id'))) {
        selectedAnswers = this.state.selectedAnswers.delete(answer.get('id'));
      } else {
        selectedAnswers = this.state.selectedAnswers.set(answer.get('id'), answer);
      }

      this.setState({ selectedAnswers: selectedAnswers }, function () {
        _this2.props.onChange && _this2.props.onChange(_this2.state.selectedAnswers);

        if (!_this2.props.data.get('isMultipleAnswers') && !_this2.props.previewQuizScreen) {
          _this2.timeout = setTimeout(function () {
            _this2.props.handleNext && _this2.nextHandler(_this2.props.handleNext)();
          }, 300);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: this.props.className, ref: this.props.measureRef },
        _react2.default.createElement(_RenderWarnings2.default, this.props),
        (0, _RenderHelper.mountPanels)(this.mountContent, this.mountActions)
      );
    }
  }]);

  return RenderQuestion;
}(_react2.default.Component);

RenderQuestion.propTypes = {
  trackEvent: _propTypes.PropTypes.func
};
exports.default = RenderQuestion;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wse-quiz-component/lib/RenderQuestion.js
// module id = 697
// module chunks = 0